var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFolderUpload(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 57 57",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.83822 9.55127C8.51605 9.55127 8.25488 9.81244 8.25488 10.1346V47.4679C8.25488 47.7901 8.51603 48.0513 8.83822 48.0513H48.5049C48.8271 48.0513 49.0882 47.7901 49.0882 47.4679V17.1346C49.0882 16.8124 48.8271 16.5513 48.5049 16.5513H28.6716C28.1522 16.5513 27.6597 16.3206 27.3272 15.9216L22.0186 9.55127H8.83822ZM4.75488 10.1346C4.75488 7.87944 6.58305 6.05127 8.83822 6.05127H22.8382C23.3576 6.05127 23.8501 6.28196 24.1826 6.68095L29.4912 13.0513H48.5049C50.7601 13.0513 52.5882 14.8794 52.5882 17.1346V47.4679C52.5882 49.7231 50.7601 51.5513 48.5049 51.5513H8.83822C6.58307 51.5513 4.75488 49.7232 4.75488 47.4679V10.1346Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.4341 22.8972C28.117 22.2143 29.224 22.2137 29.9076 22.8958L36.9076 29.8803C37.5918 30.5629 37.593 31.671 36.9104 32.3552C36.2277 33.0393 35.1197 33.0406 34.4355 32.3579L28.6729 26.6081L22.909 32.372C22.2256 33.0555 21.1175 33.0555 20.4341 32.372C19.7507 31.6886 19.7507 30.5806 20.4341 29.8972L27.4341 22.8972Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.6716 22.3846C29.6381 22.3846 30.4216 23.1681 30.4216 24.1346V40.4679C30.4216 41.4344 29.6381 42.2179 28.6716 42.2179C27.7051 42.2179 26.9216 41.4344 26.9216 40.4679V24.1346C26.9216 23.1681 27.7051 22.3846 28.6716 22.3846Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolderUpload);
export default __webpack_public_path__ + "static/media/folder-upload.3e2676c3.svg";
export { ForwardRef as ReactComponent };